import { Txt } from '@vst/beam';

import { AddonIcon } from '@app/components/AddonIcon';

import styles from '../../styles/cart.module.scss';

type AddonProps = {
  name: string;
  kind: string;
};

const CartAddonName = ({ name, kind }: AddonProps) => {
  return (
    <div className={styles['addon']}>
      <AddonIcon kind={kind} className={styles['icon']} />
      <Txt variant="paragraphBold" color="regular">
        {name}
      </Txt>
    </div>
  );
};

export default CartAddonName;
